import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { Box, Chip } from '@/DesignSystem/Component';
import { preparePersonNameFamily } from '@/Module/Core/Helper/preparePersonNameFamily';
import { useAppSelector } from '@/Module/Store/Hook';
import { prepareTeacherUrlTeacherPage } from '@/Module/Teacher/Helper';
import type { ITeacher } from '@/Module/Teacher/Model/DataModel';
import type { ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel/ITeacherCategoryList';
import { categoryTeacherListTeacherSelector } from '@/Module/Teacher/Store/Selector/categoryTeacherListTeacherSelector';
import type { ITeacherColor } from './TeacherRowByCategory';
const TITLE_COLORS: Record<ITeacherColor, string> = {
  orange: 'text-redThree bg-orangeOne',
  pink: 'text-pinkFour bg-pinkOne',
  primary: 'text-blueFour bg-blueOne '
};
const NAME_COLORS: Record<ITeacherColor, string> = {
  orange: 'text-orangeFive',
  pink: 'text-pinkFive',
  primary: 'text-blueFive'
};
const PHOTO_COLORS: Record<ITeacherColor, string> = {
  orange: 'bg-teacher-orange',
  pink: 'bg-teacher-pink',
  primary: 'bg-teacher-primary'
};
interface IProps {
  teacherId: ITeacher['id'];
  categoryTeacherId: ITeacherCategoryListCategory['id'];
  color: ITeacherColor;
}
const Teacher: FC<IProps> = ({
  teacherId,
  categoryTeacherId,
  color
}) => {
  const teacher = useAppSelector(state => categoryTeacherListTeacherSelector(state, categoryTeacherId, teacherId));
  if (!teacher) return null;
  const categoryTeacher = teacher.courseInfoes[0].name;
  return <div className="flex flex-1  flex-row items-center justify-between" data-sentry-component="Teacher" data-sentry-source-file="Teacher.tsx">
      <Box as={Link} href={prepareTeacherUrlTeacherPage(teacher)} color={color} className={cs('cursor-pointer', PHOTO_COLORS[color])} data-sentry-element="Box" data-sentry-source-file="Teacher.tsx">
        <Image src={teacher.coverUrl} alt="test" width="120" height="120" data-sentry-element="Image" data-sentry-source-file="Teacher.tsx" />
      </Box>
      <div className="flex-1 pr-4 ">
        {categoryTeacher ? <Chip className={cs('mb-4 text-base !px-2 ', TITLE_COLORS[color])} title={`${categoryTeacher}`} /> : ''}

        <Link href={prepareTeacherUrlTeacherPage(teacher)} className={cs('text-2xl flex font-bold mb-1 cursor-pointer', NAME_COLORS[color])} data-sentry-element="Link" data-sentry-source-file="Teacher.tsx">
          <h2>{preparePersonNameFamily(teacher)}</h2>
        </Link>
        <span className={cs('text-base', NAME_COLORS[color])}>سامانه آموزش مجازی آی‌نو</span>
      </div>
    </div>;
};
export default Teacher;